import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-bell',
    templateUrl: './icon-bell.component.html',
    styleUrls: ['./icon-bell.component.scss'],
    standalone: false
})
export class IconBellComponent {
  @Input() color = '#2F609F';
  @Input() width = '17';
  @Input() height = '20';
}
